import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import InputFile from "components/elements/inputFile";
// import Loading from "components/Loading";
import { uploadImage } from "actions/websiteActions";
import { connect } from "react-redux";

const ModalSearchImage = ({ uploadImage, onSearch }) => {
    const [isOpen, setIsOpen] = useState(false);
    // const [loading, setLoading] = useState(false);
    const [images, setImages] = useState("");
    const [aiText, setAiText] = useState("");
    const onClose = () => {
        setIsOpen(false);
    };

    // const handleUploadImage = async (e, key = "main_images") => {
    //     const images = Object.values(e).filter((f) => f.type.includes("image"));

    //     if (images.length) {
    //         setLoading(true);
    //         const postData = await uploadImage(images);
    //         const links = postData?.arr_images || [];
    //         setImages(links?.[0] || "");
    //         setLoading(false);
    //     }
    // };

    const handleSubmit = () => {
        onClose();
        if (images) {
            onSearch?.(images, aiText);
        }
    };

    return (
        <>
            {/* <Loading isLoading={loading} /> */}
            <button
                className="btn btn-info"
                type="button"
                onClick={() => {
                    setIsOpen(true);
                }}
            >
                <i className="fas fa-camera-retro"></i>
            </button>
            <Modal
                centered={true}
                size="xl"
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h2 className="mb-0 text-info">Search Image</h2>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="d-flex justify-content-between mb-5 w-100 flex-column gap-4">
                        <div className="d-flex gap-2">
                            <div
                                className="d-flex flex-column d-flex align-items-center border p-10"
                                style={{ flex: "1 1 50%" }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter image URL"
                                    value={images}
                                    onChange={(e) => setImages(e.target.value)}
                                />
                                {/* <InputFile multiple={false} onChange={handleUploadImage}>
                                    <button
                                        className="btn btn-danger ms-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#kt_modal_create_app"
                                        id="kt_toolbar_primary_button"
                                    >
                                        <i className="ki-outline ki-cloud-download"></i>
                                        Upload Image
                                    </button>
                                </InputFile> */}
                                {images && (
                                    <img
                                        src={images}
                                        alt=""
                                        className="al-product-img border p-4 mt-4"
                                        draggable="false"
                                        style={{ objectFit: "cover", width: "200px", height: "200px" }}
                                    />
                                )}
                            </div>
                            <div
                                className="d-flex justify-content-center d-flex align-items-center border p-10"
                                style={{ flex: "1 1 50%" }}
                            >
                                <textarea
                                    className="form-control"
                                    rows="10"
                                    placeholder="（Optional）Enter additional keywords to help AI search more accurately"
                                    value={aiText}
                                    onChange={(e) => setAiText(e.target.value)}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        Save
                    </button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default connect(null, { uploadImage })(ModalSearchImage);
